import { useState } from "react";
import { AuthApiClient } from "../api-client/api-client";
import { usePrivy } from "@privy-io/react-auth";
import { useQueryClient } from "@tanstack/react-query";
import { jwtPayload } from "../types";
import { jwtDecode } from "../invalid-token-error";
import { useAppDispatch } from "@/redux/hooks";
import { setJwt } from "../utils";
import {
  setExpirationToken,
  setLinkedCompanies,
  setRoles,
  setUser
} from "@/redux/slices/userSlice";

export const useRefreshUser = () => {
  const [isRefreshTokenLoading, setIsRefreshTokenLoading] = useState(false);
  const { logout: privyLogout, authenticated } = usePrivy();
  const queryClient = useQueryClient();
  const dispatch = useAppDispatch();

  const refreshToken = async () => {
    try {
      setIsRefreshTokenLoading(true);
      const { token } = await AuthApiClient.refresh();
      if (token) {
        const decoded: jwtPayload = jwtDecode(token);
        const { exp, roles, linked_companies } = decoded;
        if (roles) dispatch(setRoles({ roles: roles }));
        if (linked_companies) dispatch(setLinkedCompanies({ linkedCompanies: linked_companies }));
        dispatch(setExpirationToken(Number(exp)));
        setJwt({ token });
        setIsRefreshTokenLoading(false);
      } else {
        await logout();
      }
    } catch (_) {
      await logout();
    }
  };
  const logout = async () => {
    if (authenticated) await privyLogout();

    setJwt({ token: null });
    dispatch(setExpirationToken(null));
    dispatch(setUser(null));
    queryClient.clear();
    sessionStorage.removeItem("NewOlkyPayUser");
    sessionStorage.removeItem("username");
    sessionStorage.removeItem("jwt");
  };

  return { refreshToken, logout, isRefreshTokenLoading };
};
